<template>
  <div class="dashboard-block" v-if="!booking.is_offer">
    <h2>
      Manager Notifications

      <a
        data-toggle="modal"
        data-target="#modal-notify-managers"
        data-backdrop="static"
        class="btn btn-sm pull-right"
        v-if="userCanNotifyManagers">
        <i class="fa fa-plus"></i>
        <template v-if="$userIsAdmin">Notify Managers</template>
      </a>
    </h2>

    <div v-if="haveNoManagersNotified" class="text-center alert alert-default">
      There are no notified managers.
    </div>

    <ul v-else class="tags">
      <li v-for="manager in booking.managers_notified" :key="manager.id">
        <span>{{ manager.name }}</span>
      </li>
    </ul>

    <booking-notify-managers-modal
      v-if="$userIsAdmin"/>
  </div>
</template>

<script>
import { helpers } from 'mixins/bookings'
import BookingNotifyManagersModal from './BookingNotifyManagersModal'

export default {
  mixins: [helpers],

  props: {
    booking: {
      required: true,
      type: Object
    }
  },

  components: {
    BookingNotifyManagersModal
  },

  data () {
    return {
      talentToAdd: []
    }
  },

  computed: {
    haveNoManagersNotified () {
      return !this.booking.managers_notified || this.booking.managers_notified.length === 0
    },

    userCanNotifyManagers () {
      if (this.$userIsNonGlobalAdmin && this.booking.region_id !== this.$user.region_id) {
        return false
      }
      if (this.$userIsAdmin) {
        return this.bookingTypeIsBookingRequest &&
          this.bookingIsPending &&
          this.bookingIsPublic
      }
    }
  }
}
</script>
